export const programId = '621917c8c3e1054d36ce000f';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
};
